<template>
  <div id="productDetail">
    <NavigationBar />

		<div class="uk-section" 
				id="topBanner" 
				style="background-color:white" >
			<div class="uk-container">
				<div class="uk-flex uk-flex-center uk-flex-middle uk-height-medium uk-height-max-small" uk-grid>
					<div class="uk-text-center">
						<!-- <p class="uk-text-large" uk-scrollspy="cls: uk-animation-slide-top; delay: 500; repeat: false;">Category</p> -->
						<p class="uk-heading-small uk-text-bold uk-margin-remove uk-text-uppercase" uk-scrollspy="cls: uk-animation-slide-bottom; delay: 500; repeat: false; ">{{ category }}</p>
					</div>
				</div>
			</div>
		</div>
    <h1 class="uk-heading-divider"></h1>
    <div v-if="!loading">
      <div v-if="videoUrl != ''" class="uk-section uk-padding-remove-bottom">
        <div class="uk-container ">
          <VideoCategory :videoUrl="videoUrl" />
        </div>
      </div>

      <div class="uk-section">
        <div class="uk-container ">
          <div v-if="!loading" class="uk-grid uk-grid-match" uk-grid uk-scrollspy="cls: uk-animation-scale-up; delay: 500; repeat: true;">
            <div class="uk-width-1-4@s uk-text-center" v-for="product in data">
              <div @click="openProduct(product.seo_url)" class="cursor uk-card uk-box-shadow-hover-xlarge uk-card-default uk-background-primary" uk-scrollspy="cls: uk-animation-scale-up; delay: 500; repeat: false;">
                <div class="uk-card-media-top">
                    <img :src="product.thumbnail" width="1800" height="1200" :alt="product.name">
                </div>
                <div class="uk-card-body uk-padding-remove">
                  <div class="uk-margin-top uk-margin-bottom uk-margin-left uk-margin-right">
                    <p class="font-white">{{ product.name }}</p>
                    <!-- <p class="uk-margin-remove">{{ item.media }}</p>
                    <p class="uk-margin-remove uk-text-small uk-text-muted">{{ item.date }}</p>
                    <button @click="goTo(item.url)" class="uk-button uk-button-primary uk-text-capitalize uk-margin-small-top">Read More</button> -->
                  </div>
                </div>
              </div>
              <!-- <img class="uk-width-1-1" :src="product.image" alt="TV Image"> -->
            </div>
          </div>
          <div
            class="uk-flex uk-flex-center uk-flex-middle"
            style="height: 100%"
            v-else
          >
            <div uk-spinner></div>
          </div>
        </div>
      </div>
    </div>
    <div v-else class="uk-section" style="height: 70vh">
      <div class="uk-container" style="height: 100%">
        <div
          class="uk-flex uk-flex-center uk-flex-middle"
          style="height: 100%"
        >
          <div uk-spinner></div>
        </div>
      </div>
    </div>
    <h1 class="uk-heading-divider"></h1>
    <Footer />
  </div>
</template>

<script>
import NavigationBar from "@/components/NavigationBar.vue";
import Footer from "@/components/Footer.vue";
import NavbarMobileComponent from "@/components/NavbarMobileComponent.vue";
import VueCompareImage from "vue-compare-image";
import axios from "axios";
import { mapGetters } from "vuex";
import VideoCategory from './components/VideoCategory.vue';


export default {
  name: "productView",
  components: {
    NavigationBar,
    Footer,
    NavbarMobileComponent,
    VueCompareImage,
    VideoCategory,
  },
  data() {
    return {
      data: {},
      banner: require('../../assets/woman-in-white-blazer-holding-tablet-computer-789822EDIT.jpg'),
      loading: true,
      category: '',
      products: [],
      videoUrl: '',
    };
  },
  computed: {
    ...mapGetters("auth", ["IS_AUTH", "GET_USER"]),
    isSmall() {
      return window.innerWidth < 960;
    },
    isVerySmall() {
      return window.innerWidth < 640;
    },
  },
  watch: {
    // call again the method if the route changes
    // $route: "getProduct",
    '$route.params.id': {
      immediate: true,
      handler(newVal) {
        this.category = this.replaceDashWithSpace(newVal);
        // this.loadProduct();
        this.getProduct();
        this.getVideoUrl();
      }
    }
  },
  mounted() {
    this.category = this.$route.params.id
    this.category = this.replaceDashWithSpace(this.category)
    // this.loadProduct();
    this.getProduct();
    this.getVideoUrl();
  },
  methods: {
    replaceDashWithSpace(str) {
      return str.replace(/-/g, ' ');
    },
    getVideoUrl(){
      if(this.category === 'smart camera'){
        this.videoUrl = `https://www.youtube.com/embed/YjeiqaZ4_nU`;
      } else if(this.category === 'smart tv'){
        this.videoUrl = `https://www.youtube.com/embed/5384QtBeZ9w`;
      } else {
        this.videoUrl = ''
      }
    },
    getProduct() {
      this.loading = true;
      axios
        .get(
          `${process.env.VUE_APP_API_ROOMI_URL}product/category/${this.$route.params.id}`
        )
        .then((res) => {
          if (res.status == 200) {
            const data = res.data;
            this.data = data.data;
            this.setSeo();
            this.loading = false;
          } else {
            this.$router.push("/not-found");
          }
        })
        .catch((err) => {
          this.$router.push("/not-found");
        });
    },
    setSeo() {
      let titlePage = this.category.toUpperCase() + " from Roomi";
      const siteDescription = this.data.description;
      document.title = titlePage;
      const check_meta = document.querySelectorAll("meta");
      let count_check = 0;
      check_meta.forEach((check) => {
        if (
          check.getAttribute("name") == "description" ||
          check.getAttribute("name") == "title" ||
          check.getAttribute("name") == "robots"
        ) {
          if (check.getAttribute("name") == "description") {
            check.setAttribute("content", "");
          }
          if (check.getAttribute("name") == "title") {
            check.setAttribute("content", titlePage);
          }
          if (check.getAttribute("name") == "robots") {
            check.setAttribute("content", "index, follow");
          }
          count_check = 1;
        }
      });
      if (count_check == 0) {
        var meta_description = document.createElement("meta");
        meta_description.setAttribute("name", "description");
        meta_description.setAttribute("content", siteDescription);
        document.getElementsByTagName("head")[0].appendChild(meta_description);
        const meta_title = document.createElement("meta");
        meta_title.setAttribute("name", "title");
        meta_title.setAttribute("content", titlePage);
        document.getElementsByTagName("head")[0].appendChild(meta_title);
        const meta_robots = document.createElement("meta");
        meta_robots.setAttribute("name", "robots");
        meta_robots.setAttribute("content", "index, follow");
        document.getElementsByTagName("head")[0].appendChild(meta_robots);
      }
    },
    loadProduct(){
      if(this.category === 'smart camera'){
        this.products = [
          {
            name: 'SPYE',
            image: encodeURI('https://api.roomi.co.id/images/cctv SPYE.png')
          },
          {
            name: 'SPYE NIGHT',
            image: encodeURI('https://api.roomi.co.id/images/RM-I55B4S.png')
          },
          {
            name: 'SPYE NIGHT MOTION',
            image: encodeURI('https://api.roomi.co.id/images/RM-I65B4S-4CWT.png')
          },
          {
            name: 'SPYE MINI I',
            image: encodeURI('https://api.roomi.co.id/images/spye mini 1.png')
          },
          {
            name: 'SPYE MINI II',
            image: encodeURI('https://api.roomi.co.id/images/spye mini 2.png')
          }
        ]
      } else if (this.category === 'smart tv'){
        this.products = [
          {
            name: 'ROOMI T2 Digital TV',
            image: require('../../assets/images/products/roomi tv 32_ led tv.jpg')
            // image: encodeURI('https://api.roomi.co.id/images/smart-tv-led-1.jpeg')
          },
          {
            name: 'Smart Frameless Android TV',
            image: require('../../assets/images/products/roomi tv 32_frameless.jpg')
          },
          {
            name: 'Smart TV WEB-OS 2.0',
            image: require('../../assets/images/products/web os 55.jpg')
          },
          {
            name: 'GOOGLE TV',
            image: require('../../assets/images/products/google tv 86.jpg')
          },
        ]
      } else if (this.category === 'speaker'){
        this.products = [
          {
            name: 'Soundwave',
            image: require('../../assets/images/products/soundwave.jpg')
          },
          {
            name: 'Rave BOX',
            image: require('../../assets/images/products/rave box max.jpg')
          },
          {
            name: 'Wakanda Series',
            image: encodeURI('https://api.roomi.co.id/images/roomi 8.png')
          },
          {
            name: 'ROOMI PRO Series',
            image: require('../../assets/images/products/pro 10.jpg')
          },
          {
            name: 'Sonic Portable',
            image: require('../../assets/images/products/sonic.jpg')
          },
          {
            name: 'Echo Series',
            image: require('../../assets/images/products/echo.jpg')
          },
          {
            name: 'Grande',
            image: require('../../assets/images/products/grande.jpg')
          },
          {
            name: 'Velvet',
            image: require('../../assets/images/products/velvet.jpg')
          },
        ]
      } else if (this.category === 'ott box'){
        this.products = [
          {
            name: 'ROOMI OTT BOX',
            image: require('../../assets/images/products/ott box 2 gb+16gb.jpg')
          },
        ]
      } else if (this.category === 'smart led'){
        this.products = [
          {
            name: 'LUMIO',
            image: encodeURI('https://api.roomi.co.id/images/ROOMI SMART BULB 9W - NEW.png')
          },
        ]
      }
      this.loading = false
    },
    openProduct(product){
			// this.$router.push({ path: `/product/${product}` });
      this.$router.push({ name: 'product-detail', params: { categoryid: this.replaceSpaceWithDash(this.category), productid: this.replaceSpaceWithDash(product) } })
		},
    replaceSpaceWithDash(str) {
      return str.replace(/\s+/g, "-").toLowerCase();;
    },
  },
};
</script>

<style lang="less" scoped>
</style>